module.exports = __webpack_public_path__ + "static/img/IMG_20160224_160642.e35b8c41.jpg";